import validate from "/var/www/html/node_modules/nuxt/dist/pages/runtime/validate.js";
import maintenance from "/var/www/html/node_modules/@blumewas/nuxt-maintenance/dist/runtime/middleware/maintenance.js";
import _00_45try_45token_45refresh_45global from "/var/www/html/middleware/00-try-token-refresh.global.ts";
import _05_45set_45locale_45global from "/var/www/html/middleware/05-set-locale.global.ts";
import _10_45access_45global from "/var/www/html/middleware/10-access.global.ts";
import _20_45init_45admin_45global from "/var/www/html/middleware/20-init-admin.global.ts";
import _21_45init_45profile_45store_45global from "/var/www/html/middleware/21-init-profile-store.global.ts";
import manifest_45route_45rule from "/var/www/html/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  maintenance,
  _00_45try_45token_45refresh_45global,
  _05_45set_45locale_45global,
  _10_45access_45global,
  _20_45init_45admin_45global,
  _21_45init_45profile_45store_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "dev-only": () => import("/var/www/html/middleware/dev-only.js"),
  "maintenance-bypassed": () => import("/var/www/html/middleware/maintenance-bypassed.js"),
  "product-access": () => import("/var/www/html/middleware/product-access.js")
}